import React, {useState,useEffect, useRef} from "react"
import { formatText, linkify } from '../../utility/MessageFormatter';

function MessageViewer({messageData}){
    const maxLines = 8
    const [isExpanded, setIsExpanded] = useState(false);
    const textRef = useRef();

    const toggleExpansion = () => {
        setIsExpanded(!isExpanded);
    };
    const hasLargeContent = textRef?.current?.clientHeight > 120

    const textStyle = {
        display: 'inline-block',
        WebkitLineClamp: isExpanded ? 'unset' : maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '1.5em',
        maxHeight: isExpanded ? 'none' : `${maxLines * 1.5}em`,
        whiteSpace: 'pre-wrap',
    };

    return(
        <>
            {
                process.env.REACT_APP_CLIENT === "GEMS" ?
                    <>
                        <div ref={textRef} style={ hasLargeContent ? textStyle : null} dangerouslySetInnerHTML={{ __html: linkify(formatText(messageData)) }} className="trunkate-message-title test-html"></div>
                        {hasLargeContent && <span
                            style={{ cursor: 'pointer',fontSize : '10px', color: 'var(--btn-bg)', display: "block" }}
                            onClick={toggleExpansion}
                            >
                            {isExpanded ? '<< Read Less' : 'Read More >>'}
                        </span>}
                    </>
                :
                    <div ref={textRef} dangerouslySetInnerHTML={{ __html: linkify(formatText(messageData)) }} className="trunkate-message-title test-html"></div>
            }
        </>
    )
}
export default MessageViewer